function removeElements<T extends HTMLElement>( selector: string ): void {
    document.querySelectorAll<T>( selector ).forEach( ( element: T ) => element.remove() );
}

export {
    removeElements,
};
